<!-- Maybe this could be a variant of menu item in prism to avoid some of the duplicated code -->
<template>
  <MenuItem as="button" :on-click="props.onClick" :isLoading="props.isLoading" :disabled="props.disabled">
    <template #start>
      <slot name="start" />
    </template>
    <template #title>
      <p class="text-typo-primary font-semi-bold text-sm mb-0">{{ props.title }}</p>
    </template>
    <template #description>
      <p class="text-typo-tertiary text-sm mb-0">{{ props.description }}</p>
    </template>
    <template #end>
      <slot name="end" />
    </template>
  </MenuItem>
</template>

<script setup lang="ts">
import { MenuItem } from "prism";

interface DownloadMenuItemProps {
  title: string;
  description: string;
  isLoading?: boolean;
  disabled?: boolean;
  onClick: () => void;
}

const props = withDefaults(defineProps<DownloadMenuItemProps>(), {
  title: "",
  description: "",
  onClick: () => {
    // noop
  },
  isLoading: false,
  disabled: false,
});
</script>
